module.exports = __webpack_public_path__ + "img/trevo.c12f29ea.png";